import { render, staticRenderFns } from "./LinksResults.vue?vue&type=template&id=0ca6bce6&scoped=true&"
import script from "./LinksResults.vue?vue&type=script&lang=js&"
export * from "./LinksResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca6bce6",
  null
  
)

export default component.exports